module.exports = __webpack_public_path__ + "static/living-near-freeway-84900fa6b279a331b9defa992d11ad5b.jpg";